export default "__VITE_ASSET__Y0RluHA8__"